<nrwl-pn-two-section>
    <ng-container left>
        <div class='login-left-wp'>
            <nrwl-pn-brand-logo></nrwl-pn-brand-logo>
            <div class='login-info-wp'>
                <div class='title'>Your practice made perfect.</div>
            </div>
            <div>
                <router-outlet></router-outlet>
            </div>
        </div>
    </ng-container>
    <ng-container right>
        <iframe width="100%" height="100%" frameBorder="0" [src]="urlSafe"></iframe>
    </ng-container>
</nrwl-pn-two-section>
